export default 30
